import { render, staticRenderFns } from "./farmercreation.vue?vue&type=template&id=8e56ae92"
import script from "./farmercreation.vue?vue&type=script&lang=js"
export * from "./farmercreation.vue?vue&type=script&lang=js"
import style0 from "./farmercreation.vue?vue&type=style&index=0&id=8e56ae92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports